import { ProgressHistoryReportDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressHistoryService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProgressHistory(): Observable<ProgressHistoryReportDto[]> {
    return this.http.get<ProgressHistoryReportDto[]>(
      this.url + 'project-history-report'
    );
  }

  createProgressHistory(
    data: ProgressHistoryReportDto[]
  ): Observable<ProgressHistoryReportDto[]> {
    return this.http.post<ProgressHistoryReportDto[]>(
      this.url + 'project-history-report',
      data
    );
  }
  getSingleProgressHistory(id: string): Observable<any> {
    return this.http.get(this.url + 'project-history-report/' + id);
  }

  updateProgressHistory(
    data: ProgressHistoryReportDto[]
  ): Observable<ProgressHistoryReportDto[]> {
    return this.http.post<ProgressHistoryReportDto[]>(
      this.url + 'project-history-report/update',
      data
    );
  }

  deleteProgressHistory(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project-history-report', ids.join(', '));
    return this.http.delete(this.url + 'project-history-report', httpOptions);
  }
}
